module.exports = __webpack_public_path__ + "img/1528437684.3d0403d1.jpg";